import React, {useEffect, useState} from 'react'
import {Route, Redirect, useHistory, useLocation} from 'react-router-dom'
import {useSelector} from 'react-redux'
import Loader from "../Loader/Loader";
import {autoLogin} from "../../store/actions/auth";
import store from "../../store";

const ProtectedRoute = ({component: Component, match, ...props}) => {
    const history = useHistory()
    const location = useLocation()
    const [showLoader, setShowLoader] = useState(true)
    const [redirect, setRedirect] = useState(history.location.pathname ? history.location.pathname : '/login')
    const isLoggedIn = useSelector(state => state.authReducer.isLoggedIn)
    const user = useSelector(state => state.authReducer.user)
    const company = useSelector(state => state.authReducer.company)
    const [forceRedirect, setForceRedirect] = useState(false)

    useEffect(() => {
        // if (isLoggedIn) return setShowLoader(false)

        store.dispatch(autoLogin()).catch(err => {
            setRedirect('/login')
            setShowLoader(false)
        })

    }, [])

    useEffect(() => {
        setRedirect('/dashboard')
        if ((user && Object.keys(user).length) && (company && Object.keys(company).length)) {

            if (user.role !== 'superadmin') {
                if (!user.emailVerified) {
                    if (location.pathname !== '/dashboard') {
                        setRedirect('/dashboard')
                        setShowLoader(false)
                        setForceRedirect(true)
                    } else {
                        setForceRedirect(false)
                    }
                }

                if (company.role === 'member') {
                    if (location.pathname !== '/dashboard') {
                        setRedirect('/dashboard')
                        setShowLoader(false)
                        setForceRedirect(true)
                    } else {
                        setForceRedirect(false)
                    }
                }
            }
        }

    }, [user, company])


    return (
        <Route {...props}
               render={(props) => (
                   isLoggedIn ?
                       forceRedirect ?
                           <Redirect to={redirect}/> :
                           <Component {...props} /> :
                       showLoader ?
                           <Loader className='mt-6 text-orange-900'/> :
                           <Redirect to={redirect}/>

               )}
        />
    )
}

export default ProtectedRoute
